import Vue from 'vue'
import Vuelidate from 'vuelidate'

import VueApexCharts from 'vue-apexcharts'
import VueFeather from 'vue-feather'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import vco from 'v-click-outside'
import flatPickr from 'vue-flatpickr-component'
import i18n from '@/plugins/i18n';
import AuthMixin from '@mixins/auth'
import uuid from 'vue-uuid';
import VueCurrencyInput from 'vue-currency-input'
import Vue2Filters from 'vue2-filters'
import VueCookie from 'vue-cookie'
import VueClipboard from 'vue-clipboard2'
import Toasted from 'vue-toasted'
import VueQuillEditor from "vue-quill-editor";
import Multiselect from 'vue-multiselect'
// import "quill-paste-smart";
import "quill/dist/quill.snow.css";
import "vue-multiselect/dist/vue-multiselect.min.css"
// import VueSocketIO from 'vue-socket.io'
import Tree from 'vuejs-tree'

// use
const pluginOptions = {
  globalOptions: { 
    currency:null,
    distractionFree:false
  }
}

// Vue.use(new VueSocketIO({
//     debug: true,
//     connection: `${process.env.VUE_APP_WEBCRAWLER_URL}`, //options object is Optional
//   })
// );

var Vue2FiltersConfig = {
  capitalize: {
    onlyFirstLetter: true
  },
  currency: {
    /* symbol: '¥', */
    decimalDigits: 2,
    thousandsSeparator: ',',
    decimalSeparator: '.',
    symbolOnLeft: true,
    spaceBetweenAmountAndSymbol: false,
    showPlusSign: false
  }
}

Vue.use(Vue2Filters, Vue2FiltersConfig)
Vue.use(VueCurrencyInput, pluginOptions)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(Vuelidate)
Vue.use(VueFeather)
Vue.use(VueQuillEditor);
Vue.use(VueCookie)
Vue.use(flatPickr)
Vue.use(uuid)
Vue.use(vco)
Vue.use(Toasted, {
  duration: 1000,
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)

//components
Vue.component('apexchart', VueApexCharts)
Vue.component('multiselect', Multiselect)
Vue.component('Tree', Tree)

//mixin
Vue.mixin(AuthMixin)

Vue.config.productionTip = false

if(!VueCookie.get('language')){
  VueCookie.set('language', 'us', 7)
}

i18n.locale = VueCookie.get('language')

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
